




















































import {Component, Prop, Watch} from 'vue-property-decorator';
import {BloodPressure, Client, Medicine, Prescription} from "@/core/services/MedicaPro/models";
import {Api} from "@/core/services/MedicaPro/Api";
import {BaseList} from "@/core/components/BaseList";
import bus from "@/main";
import DateView from "@/components/Shared/DateView.vue";

@Component({
    components: {DateView}
})
export default class ClientDetailsPageBloodPressureListView extends BaseList {

    // Bindings to parent
    @Prop() client!: Client;

    // Bindings to view
    public modelName = 'bloodPressure';
    public items: BloodPressure[] = [];
    public headers = [
        {text: 'Dato', value: 'date', sortable: false},
        {text: 'Systolisk', value: 'systolic', sortable: false},
        {text: 'Diastolisk', value: 'diastolic', sortable: false},
        {text: 'Puls', value: 'pulse', sortable: false},
        {text: '', value: 'actions', sortable: false},
    ];

    public created() {
        super.created();
    }

    public mounted() {
        super.mounted();
    }

    protected getItems(doItems = true, doCount = false) {
        // Get options from DataTable
        const options: any = this.options;

        // Mark as Loading
        this.loading = true;

        // Prepare API call
        const api = Api.bloodPressures().get()
            .where('client_id', this.client.id!);

        if (doItems) {
            api
                .limit(options.itemsPerPage)
                .offset(options.itemsPerPage * (options.page - 1))
                .orderDesc('date')
                .find(items => {
                    this.items = items;
                    this.loading = false;
                });
        }

        // Count total amount of items
        if (doCount) {
            api.count(count => {
                this.totalItems = count;
            });
        }
    }

    public createItem() {
        bus.$emit(
            `bloodPressureEdit`,
            BloodPressure.Create(this.client)
        );
    }

    public deleteItem(item: BloodPressure) {
        this.$confirm(`Er du sikker på, at du vil slette måling?`).then(res => {
            if (res) {
                Api.bloodPressures().deleteById(item.id!).delete(item => {
                    this.getItems(true, true);
                });
            }
        });
    }

}
